import { jsxs, jsx } from "react/jsx-runtime";
import { useRef, createRef } from "react";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { Stack } from "@mui/material";
import { MaxWidth } from "../EzAppLayout/EzAppLayout.es.js";
import EzHeading from "../EzHeading/EzHeading.es.js";
import EzLayout from "../EzLayout/EzLayout.es.js";
import stitches from "../theme.config.es.js";
import LinkButton from "./LinkButton.es.js";
import { TabList, Tab } from "./Tabs.es.js";
import { clsx } from "../../utils/mergeProps.es.js";
import EzIcon from "../EzIcon/EzIcon.es.js";
import { wrapEvent } from "../../utils/wrapEvent.es.js";
const pageHeader = stitches.css({
  backgroundColor: "$page-header-bg",
  boxShadow: "$page-header-box-shadow",
  padding: "$page-header-py $page-header-px",
  "@medium": {
    padding: "$page-header-md-py $page-header-md-px"
  },
  variants: {
    subNav: {
      true: { "&&": { paddingBottom: 0 } },
      false: {}
    },
    subHeader: {
      true: { "@medium": { py: "$page-header-md-subheader-py" } },
      false: {}
    }
  }
});
const handleKeyDown = (refs, { tabs, selected }) => (event) => {
  const selectedIndex = selected ? tabs.findIndex((link) => link === selected) : 0;
  const count = tabs.length;
  let nextIndex;
  switch (event.key) {
    case "ArrowDown":
    case "ArrowRight": {
      nextIndex = (selectedIndex + 1) % count;
      break;
    }
    case "ArrowUp":
    case "ArrowLeft": {
      nextIndex = (selectedIndex - 1 + count) % count;
      break;
    }
  }
  if (nextIndex === void 0) return;
  const el = refs[nextIndex];
  el.current.click();
  el.current.focus();
};
const EzPageHeader = ({
  actions,
  breadcrumb,
  status,
  title,
  subnav,
  subheader
}) => {
  const refs = useRef(subnav && subnav.tabs.map(() => createRef())).current;
  const selected = subnav && subnav.selected;
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("div", { className: clsx(pageHeader({ subNav: Boolean(subnav) })), children: /* @__PURE__ */ jsx(MaxWidth, { children: /* @__PURE__ */ jsxs(EzLayout, { layout: "stack", children: [
      /* @__PURE__ */ jsxs(
        EzLayout,
        {
          layout: {
            base: "stack",
            medium: "split"
          },
          children: [
            /* @__PURE__ */ jsxs("div", { children: [
              breadcrumb && /* @__PURE__ */ jsx(LinkButton, { ...breadcrumb, children: /* @__PURE__ */ jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [
                /* @__PURE__ */ jsx(EzIcon, { icon: faArrowLeftLong, size: "xsmall" }),
                breadcrumb.label
              ] }) }),
              /* @__PURE__ */ jsxs(
                EzLayout,
                {
                  layout: {
                    base: "stack",
                    medium: "cluster"
                  },
                  children: [
                    /* @__PURE__ */ jsx(EzHeading, { size: "1", children: title }),
                    /* @__PURE__ */ jsx("div", { children: status })
                  ]
                }
              )
            ] }),
            actions && /* @__PURE__ */ jsx(EzLayout, { layout: { base: "stack", medium: "basic" }, children: actions })
          ]
        }
      ),
      subnav && /* @__PURE__ */ jsx(TabList, { onKeyDown: handleKeyDown(refs, subnav), children: subnav.tabs.map((tab, i) => /* @__PURE__ */ jsx(
        Tab,
        {
          ref: refs[i],
          tabIndex: !selected && i === 0 || selected === tab ? 0 : -1,
          active: selected === tab,
          ...tab,
          onClick: wrapEvent(tab.onClick, () => subnav.onChange && subnav.onChange(tab))
        },
        tab.label
      )) })
    ] }) }) }),
    subheader && /* @__PURE__ */ jsx("div", { className: clsx(pageHeader({ subHeader: true })), children: /* @__PURE__ */ jsx(MaxWidth, { children: subheader }) })
  ] });
};
export {
  EzPageHeader as default
};
//# sourceMappingURL=EzPageHeader.es.js.map
